import React from 'react';

const CookiePolicy = () => {
    return (
        <div className="c">
            <label>Cookiepolicy</label>
        </div>
    );
};

export default CookiePolicy;
